import React from 'react';
import styles from './EmptyTemplate.module.scss';
import TemplateIcon from './TemplateIcon';

interface EmptyTemplateProps {
  hasTemplates: boolean;
}

const EmptyTemplate = ({ hasTemplates }: EmptyTemplateProps) => {
  return (
    <div className={styles.emptyContainer}>
      <TemplateIcon />
      <div className={styles.description}>
        {hasTemplates
          ? 'Select a template to manage'
          : 'To create a new template, select Templatize from the post dropdown menu'}
      </div>
    </div>
  );
};

export default EmptyTemplate;
